import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../services2/schoolMissions.service';
function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(0)


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        if (status !== '全部') filter.status = status
        let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        if (result.result) {
            setdata(result.result)
            settotal(result.count || 0)
        } else {
            alert('Fetch data error')
        }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])

    const togglePublicStatus = (item) => async () => {
        setisLoading(true)
        let result = await teacherUpdateSchoolMission(props.token.token, item._id, { 
            isPublic: !item.isPublic,
            disableAnswer: !!item.disableAnswer,
        })
        if (result.errno) {
            alert(result.message)
        } else {
            alert('儲存成功')
            fetchData(true)
        }
        setisLoading(false)
    }
    const toggleDisableAnswerStatus = (item) => async () => {
        setisLoading(true)
        let result = await teacherUpdateSchoolMission(props.token.token, item._id, { 
            isPublic: !!item.isPublic,
            disableAnswer: !item.disableAnswer,
        })
        if (result.errno) {
            alert(result.message)
        } else {
            alert('儲存成功')
            fetchData(true)
        }
        setisLoading(false)
    }



    return (
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]'>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>管理任務</div>
                <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                    {/* <DropDownMenu select={onSelectFilter} value={filter} options={['全部','1','2','3']}/> */}
                    {/* <div className='text-[14px] py-[8px] px-[16px] rounded-[7px] gap-[4px] flex flex-row' style={{border:'.5px solid #00000080'}}>
                    <SearchSvg/>
                    <input placeholder='搜尋'/>
                </div> */}
                </div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]'>
                <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
                    <div className='flex-1'>閲讀任務名稱</div>
                    <div className='flex-1'>分類</div>
                    <div className='flex-1'>任務</div>
                    <div className='flex-1'>時間</div>
                    <div className='flex-1'>狀態</div>
                </div>
                {data?.map((item, index) =>
                    <div key={item?._id || index} className='w-full flex flex-col py-[16px] gap-[8px]'  style={{ borderBottom: '1px solid #D1D1D1' }}>
                        <div className='w-full flex flex-row justify-between font-[400] items-center'>
                            <div className='flex-1'>{item?.mission?.name}</div>
                            <div className='flex-1'>{item?.mission?.category}</div>
                            <div className='flex-1'>{item?.mission?.mission}</div>
                            <div className='flex-1'>{item?.mission?.time || '-'} 分鐘</div>
                            <div className='flex-1 flex flex-row'>
                                {item.mission?.status === '啟動中' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>啟動中</div>
                                    : item.mission?.status === '未公開' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>未公開</div>
                                        : <div>{item?.status}</div>
                                }
                            </div>
                        </div>
                        <div className='flex w-full flex-row gap-[24px] items-center justify-start flex-wrap'>
                            
                            <div className='gap-[4px] flex flex-row items-center'>
                                開放任務:
                                <div className='w-[80px] h-[40px] rounded-[99px] flex flex-row items-center justify-center cursor-pointer hover:opacity-[.5]' style={{backgroundColor:item?.isPublic?'white':'#aaa',border:'1px solid #aaa'}} onClick={togglePublicStatus(item)}>
                                    <div className='w-[32px] h-[32px] bg-[blue] rounded-[99px] flex justify-center items-center cursor-pointer hover:opacity-[.5]' style={{opacity:item?.isPublic?1:0}}/>
                                    <div className='w-[32px] h-[32px] bg-[white] rounded-[99px] flex justify-center items-center cursor-pointer hover:opacity-[.5]' style={{opacity:item?.isPublic?0:1}}/>
                                </div>
                            </div>
                            <div className='gap-[4px] flex flex-row items-center'>
                                隱藏閱讀成績單:
                                <div className='w-[80px] h-[40px] rounded-[99px] flex flex-row items-center justify-center cursor-pointer hover:opacity-[.5]' style={{backgroundColor:item?.disableAnswer?'white':'#aaa',border:'1px solid #aaa'}} onClick={toggleDisableAnswerStatus(item)}>
                                    <div className='w-[32px] h-[32px] bg-[blue] rounded-[99px] flex justify-center items-center cursor-pointer hover:opacity-[.5]' style={{opacity:item?.disableAnswer?1:0}}/>
                                    <div className='w-[32px] h-[32px] bg-[white] rounded-[99px] flex justify-center items-center cursor-pointer hover:opacity-[.5]' style={{opacity:item?.disableAnswer?0:1}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
